// SEE: https://github.com/reactjs/rfcs/pull/220
// this has since been put into experimental react as useEffectEvent
// and only works when calling from within a useEffect
//
// The original idea was a useCallback that would always return the same function
// but would be aware of the latest state within the function
// While I don't think this should be used EVERYWHERE I do not think there
// are any downsides to using it in this case - there are plenty of cases
// where we may not want to cause a child to re-render just because the parent
// passed "a new function" to it
// TODO: more research needs to be done here to ensure that what i said is true
import {useCallback, useEffect, useRef} from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Fn = (...args: any[]) => void;

export function useConstCallback<F extends Fn>(fn: F): F {
	const fnRef = useRef<Fn>(fn);

	// useEffect(() => {
	// 	fnRef.current = fn;
	// }, [fn]);

	fnRef.current = fn;

	return useCallback((...args: any[]) => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
		return fnRef.current?.(...args);
	}, []) as unknown as F;
}

export default useConstCallback;
